import * as React from 'react';
import * as style from './Seller.css';

import { BuilderLogo } from '../../../BuilderLogo';
import { CallSeller } from '../../../CallSeller';
import { INewbuildingSeller } from '../../../../types/newbuilding/seller';
import { INewbuildingBuilder } from '../../../../types/newbuilding/builder';

export interface ISellerProps {
  seller: INewbuildingSeller;
  eventTracker(builder: INewbuildingBuilder | INewbuildingSeller): void;
}

export const Seller = (props: ISellerProps) => (
  <div className={style['seller']}>
    <BuilderLogo
      customStyles={style['seller-logo']}
      src={props.seller.avatarUrl}
      name={props.seller.name}
      website={null}
    />
    <div className={style['seller-info']}>
      <span className={style['seller-title']}>{props.seller.name}</span>
      <span className={style['seller-subtitle']}>Агентство недвижимости</span>
      <CallSeller
        dynamicCalltrackingPlaceType="buildersInfo"
        target={props.seller}
        trackActionOpenContactsCall={props.eventTracker}
      />
    </div>
  </div>
);
